
import { SnackbarProgrammatic as Snackbar } from 'buefy'
import API from '@/api'

const actions = {
  getLk({ commit }, payload) {
    API.lk.get(payload)
      .then(({ data: { data } }) => {
        commit('setLk', data)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Произошла ошибка при загрузке страницы.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
  },
}

export default actions